import { useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import { CoursesData } from "../lib/languages";
import { Card, CardContent } from "./ui/card";
import StarRating from "./StarRating";
import { Avatar, Progress } from "antd";
import { Button } from "./ui/button";
import { cn } from "../lib/utils";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import MainButton from "./MainButton";
import { Circle, Video } from "lucide-react";

export const CourseCard = ({
  courseType,
  item,
  btnTitle = "View Course",
  onClick,
  isSelected = false,
}) => {
  const { user } = useAuth();
  const [showMore, setShowMore] = useState(false);
  const { language } = useLanguage();
  const t = CoursesData[language] || CoursesData["en"];

  const toggleShowMore = (e) => {
    e.stopPropagation();
    setShowMore((prev) => !prev);
  };

  const navigateUrl =
    user?.role === "admin"
      ? "/admin/teacher-settings"
      : user?.role === "student"
      ? "/teacher-settings"
      : "/teacher/teacher-settings";

  return (
    <Card
      className={cn(
        "overflow-hidden h-full transition-all duration-300 hover:-translate-y-2",
        isSelected && "border-blue-600 ring-2 ring-blue-200"
      )}
    >
      <div className="w-full">
        <img
          src={
            item?.image ||
            "https://media.istockphoto.com/id/1147544807/vector/thumbnail-image-vector-graphic.jpg?s=612x612&w=0&k=20&c=rnCKVbdxqkjlcs3xH87-9gocETqpspHFXu5dIGB4wuM="
          }
          alt={
            item?.title?.[language] ||
            item?.title?.en ||
            item?.title?.ar ||
            "Course image"
          }
          loading="lazy"
          className="object-cover w-full h-60 scale-105"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src =
              "https://media.istockphoto.com/id/1147544807/vector/thumbnail-image-vector-graphic.jpg?s=612x612&w=0&k=20&c=rnCKVbdxqkjlcs3xH87-9gocETqpspHFXu5dIGB4wuM=";
          }}
        />
      </div>
      <CardContent className="p-4 space-y-3">
        <div className="flex items-center gap-2">
          <Link
            to={navigateUrl}
            state={{ userData: item?.created_by }}
            className="flex items-center gap-2"
          >
            <div className="w-8 h-8 rounded-full overflow-hidden shadow-md">
              <Avatar
                src={item?.created_by?.image}
                className={cn(
                  "w-8 h-8 rounded-full flex items-center justify-center text-xs font-medium",
                  "bg-blue-100 text-blue-600",
                  "dark:bg-blue-900 dark:text-blue-300"
                )}
              >
                {item?.created_by?.name?.substring(0, 2).toUpperCase()}
              </Avatar>
            </div>
            <p className="font-semibold text-muted-foreground truncate text-sm">
              {item?.created_by?.name || "Instructor"}
            </p>
          </Link>
        </div>
        <p className="font-semibold text-lg">
          {item?.title?.[language] ||
            item?.title?.en ||
            item?.title?.ar ||
            "Course Title"}
        </p>
        <div>
          <div
            className={`text-muted-foreground ${
              !showMore ? "line-clamp-2" : ""
            }`}
          >
            {item?.description?.[language] ||
              item?.description?.en ||
              item?.description?.ar ||
              "Course description"}
          </div>
          {item?.description?.[language]?.length > 250 && (
            <button
              type="button"
              className="p-0 text-primary underline-offset-4 underline text-sm cursor-pointer inline-block font-semibold mt-1"
              onClick={toggleShowMore}
            >
              {showMore ? t.showLess || "Show less" : t.showMore || "Show more"}
            </button>
          )}
        </div>
        <div className="flex justify-between flex-wrap gap-2">
          <p className="text-sm font-medium">
            {item?.type === 1 ? (
              <div className="text-red-500 flex items-center gap-1">
                <Circle className="size-4 fill-red-500" /> {t.live}
              </div>
            ) : (
              <div className="text-green-500 flex items-center gap-1">
                <Video className="size-5" /> {t.recorded}
              </div>
            )}
          </p>
          <StarRating rating={item?.rate || 0} />
        </div>

        {/* {courseType === "current" && (
          <div>
            <p className="flex items-center gap-2 justify-between font-semibold text-muted-foreground text-sm">
              <span className="text-green-500">{item?.progress || 0}%</span>{" "}
              <span>{item?.completedLectures || "0/0 completed"}</span>
            </p>
            <Progress percent={item?.progress || 0} className="h-2" />
          </div>
        )} */}

        {btnTitle ? (
          <MainButton title={btnTitle} onClick={onClick} className={"w-full"} />
        ) : (
          <Button
            className="w-full"
            onClick={onClick}
            variant={isSelected ? "secondary" : "default"}
          >
            "View Course"
          </Button>
        )}
      </CardContent>
    </Card>
  );
};
